import { cn } from '../../lib/utils'

interface Props { size?: 'sm' | 'md' | 'lg'; className?: string }

const sizes = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-8 h-8' }

export function Spinner({ size = 'md', className }: Props) {
  return (
    <div className={cn(
      'animate-spin rounded-full border-2 border-gray-200 border-t-primary-600',
      sizes[size], className,
    )} />
  )
}

export function PageSpinner() {
  return (
    <div className="flex items-center justify-center h-64">
      <Spinner size="lg" />
    </div>
  )
}
